export const nameLengthError = 'Name must be between 5 and 100 characters'

export function validateFunnelName(funName: string) {
  if (funName.trim().length < 5 || funName.trim().length > 100) {
    return false
  }
  return true
}
